export default __webpack_public_path__ + "img/placeholder-machine.asset.d1aa0a70.png";